import React, { useState } from 'react';
import PushPinIcon from '@mui/icons-material/PushPin'; // MUI Icon
import { updateProduction } from 'services/api/production'; // API Service function to pin a production
import { useQueryClient } from '@tanstack/react-query';

export default function PinProduction({ isPinned: initialIsPinned, productionID, userID, productions }) {
    const [isPinned, setIsPinned] = useState(initialIsPinned); // Define a state variable to keep track of pin status
    const queryClient = useQueryClient();
    const user = JSON.parse(localStorage.getItem('user'));

    const handlePinProduction = async (productionId, userId) => {
        try {
            const production = productions.find((p) => p._id === productionId); // Get the production from your local state
            let newPinnedBy;

            if (production) {
                if (production.pinnedBy && production.pinnedBy.includes(userId)) {
                    // If user has already pinned this production, unpin it
                    newPinnedBy = production.pinnedBy.filter((id) => id !== userId);
                    setIsPinned(false); // Update the pin status to false (unpinned)
                } else {
                    // Else, pin it
                    // If there is no pinnedBy field, default to an empty array
                    newPinnedBy = [...(production.pinnedBy || []), userId];
                    setIsPinned(true); // Update the pin status to true (pinned)
                }

                await updateProduction(productionId, { pinnedBy: newPinnedBy }); // Update the production with the new pinnedBy array
                queryClient.invalidateQueries({ queryKey: ['fetchPinnedProductions', user?.userID] });
                queryClient.invalidateQueries({ queryKey: ['searchProductions'] });
            } else {
                console.log(`Production with ID ${productionId} not found`);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <PushPinIcon
                onClick={() => handlePinProduction(productionID, userID)}
                style={isPinned ? { color: 'blue', cursor: 'pointer' } : { color: 'grey', cursor: 'pointer' }}
            />
        </div>
    );
}
